import type { SelectFieldOptions } from "./Field";
import { useUser } from "@/hooks/useUser";
import { defaultStatusOptions, statusIconMap } from "@/utils/status-utils";

// Custom hook to get status options - uses custom settings if available, otherwise defaults
export const useStatusOptions = (): SelectFieldOptions[] => {
  const { currentUser } = useUser();

  // Check if custom status list exists in user settings
  if (currentUser?.extraData?.customSettings?.status && currentUser.extraData.customSettings.status.length > 0) {
    // Map custom statuses to SelectFieldOptions
    return currentUser.extraData.customSettings.status.map((status) => {
      return {
        value: status.name,
        label: status.name || "", // Ensure label is always a string
        icon: statusIconMap[status.name] || statusIconMap["Received"], // Default to Received icon
      };
    });
  }

  // Fall back to default options if no custom statuses
  return defaultStatusOptions;
};
